import RegisterKeyModal from "./RegisterKeyModal";

export default RegisterKeyModal;
